/** Reusable paywall block — drop into a page when the API returns 402. */
import { useNavigate } from "react-router-dom";
import { T } from "@/lib/theme";

export function PaywallCard({ needed = "pro", currentPlan = "free", message }) {
  const nav = useNavigate();
  return (
    <div data-testid="paywall-card" style={{
      background: "linear-gradient(135deg,#0A1628 0%,#1E3050 100%)",
      borderRadius: 14, padding: "40px 32px", textAlign: "center", color: "#fff", marginBottom: 24,
    }}>
      <div style={{ fontSize: 44, marginBottom: 12 }}>🔒</div>
      <h2 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 10px" }}>
        Unlock with the <span style={{ color: T.greenAccent }}>{needed.charAt(0).toUpperCase() + needed.slice(1)}</span> plan
      </h2>
      <p style={{ color: "#94A3B8", fontSize: 14, maxWidth: 460, margin: "0 auto 22px", lineHeight: 1.6 }}>
        {message || "This feature is part of WaveScorePro's premium analytics suite. Upgrade to see live audience numbers, demographic breakdowns, and the Airtime Value Engine."}
      </p>
      <button data-testid="paywall-cta" onClick={() => nav("/billing")}
        style={{ background: T.greenAccent, color: "#fff", border: "none", padding: "12px 28px", borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
        See plans →
      </button>
      <div style={{ color: "#64748B", fontSize: 11, marginTop: 12 }}>You're on the <b>{currentPlan}</b> plan.</div>
    </div>
  );
}
